import React, { useState, useImperativeHandle, forwardRef } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from '@mui/material';
import { Delete as DeleteIcon } from '@mui/icons-material';
import {
  RewardPartnerCompanyUser,
  updateRewardPartnerCompanyUserAsync
} from '../../../../redux/slices/rewardPartnerCompanySlice';
import { useDispatch } from 'react-redux';

interface User {
  _id: string;
  phone: string;
}

interface PartnerCompanyUsersModalProps {
  onSave: () => void;
}

export interface PartnerCompanyUsersModalHandles {
  openEditModal: (companyId: string, users: RewardPartnerCompanyUser[]) => void;
}

const PartnerCompanyUsersModal = forwardRef<
  PartnerCompanyUsersModalHandles,
  PartnerCompanyUsersModalProps
>(({ onSave }, ref) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState<boolean>(false);
  const [users, setUsers] = useState<User[]>([]);
  const [currentCompanyId, setCurrentCompanyId] = useState<string>('');
  const [newPhone, setNewPhone] = useState<string>('');

  useImperativeHandle(ref, () => ({
    openEditModal(companyId: string, usersList: User[]) {
      setCurrentCompanyId(companyId);
      setUsers(usersList);
      setOpen(true);
    }
  }));

  const handleClose = () => {
    setOpen(false);
  };

  const addUser = async () => {
    if (!newPhone) return;
    dispatch(
      updateRewardPartnerCompanyUserAsync(currentCompanyId, newPhone, 'add')
    );
    setUsers([...users, { _id: Date.now().toString(), phone: newPhone }]);
    setNewPhone('');
  };

  const removeUser = async (phone: string) => {
    dispatch(
      updateRewardPartnerCompanyUserAsync(currentCompanyId, phone, 'delete')
    );
    setUsers(users.filter(user => user.phone !== phone));
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth='sm'>
      <DialogTitle>Редагувати користувачів компанії</DialogTitle>
      <DialogContent>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Номер телефону</TableCell>
                <TableCell align='right'>Дії</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {users.map(user => (
                <TableRow key={user._id}>
                  <TableCell>{user.phone}</TableCell>
                  <TableCell align='right'>
                    <IconButton onClick={() => removeUser(user.phone)}>
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TextField
          margin='dense'
          label='Додати номер телефону'
          fullWidth
          variant='standard'
          value={newPhone}
          onChange={e => setNewPhone(e.target.value)}
        />
        <Button onClick={addUser} color='primary'>
          Додати
        </Button>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Закрити</Button>
      </DialogActions>
    </Dialog>
  );
});

export default PartnerCompanyUsersModal;
